import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as  R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import LeadComponent from '../components/lead.component';
import { leads } from '../../../../../../redux/leads/action';
import { shippingTypes } from '../../../../../../redux/shippingTypes/action';
import { selectShippingTypesListItems } from '../../../../../../redux/shippingTypes/selector';
import { selectLeadsQueryItems } from '../../../../../../redux/leads/selector';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { selectMeasureDimensionsListItems } from '../../../../../../redux/measure-dimensions/selector';
import { selectMeasureWeightsListItems } from '../../../../../../redux/measure-weights/selector';
import { measureDimensions } from '../../../../../../redux/measure-dimensions/action';
import { measureWeights } from '../../../../../../redux/measure-weights/action';
import PageLoader from '../../../../../../components/PageLoader';


const ManagementTransportLead = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const parmas: any = useParams()
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const measureDimensionsLists = useSelector(selectMeasureDimensionsListItems)
	const measureWeightLists = useSelector(selectMeasureWeightsListItems)
	const result = useSelector(selectCurrent)
	const leadQuery = useSelector(selectLeadsQueryItems)
	const shippingTypeListItems = useSelector(selectShippingTypesListItems)
	const [isQuery, setIsQuery] = useState<boolean>(false)
	const [
		leadDetails,
		setLeadDetails
	] = useState<any>([])
	const [
		selectedLead,
		setSelectedLead
	] = useState<any>([])
	const [pickupLocations, setPickupLocation] = useState<any>({
		name: result?.searchedLocation?.name || '',
		lat: result?.searchedLocation?.lat || '',
		long: result?.searchedLocation?.long || '',
		pincode: result?.searchedLocation?.pincode || '',
		description: result?.searchedLocation?.description || '',
	});
	const [dropLocations, setDropLocation] = useState<any>({
		name: result?.searchedToLocation?.name || '',
		lat: result?.searchedToLocation?.lat || '',
		long: result?.searchedToLocation?.long || '',
		pincode: result?.searchedToLocation?.pincode || '',
		description: result?.searchedToLocation?.description || '',
	});
	const handleInnerFormChange: any = (event: any, field: string) => {
		setSelectedLead({ ...selectedLead, [field]: event })
	}
	const fetchLeadById = () => {
		dispatch(leads.query({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/query`, entity: 'leads', jsonData: {

				Records: [
					{
						Context: {},
						Message: { Id: parmas?.id }
					}
				]

			}
		})).then(() => {
			setIsQuery(true)
		}).then(() => {
			setIsLoading(false)
		})
	}

	const getCategoryName = (shippingTypeId: any) => {
		const ShippingTypeName = R.find(
			(shippingType: any) => parseInt(
				shippingType.Id,
				10
			) === parseInt(
				shippingTypeId,
				10
			),
			shippingTypeListItems?.result?.items
		)
		return ShippingTypeName ? ShippingTypeName.ShippingTypeName : ''
	}
	useEffect(
		() => {
			dispatch(shippingTypes.list({
				url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {

				}
			})).then(() => {
				dispatch(measureDimensions.list({
					url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-dimensions/list`,
					entity: 'measureDimensions',
					jsonData: {}
				}))
			}).then(() => {
				dispatch(measureWeights.list({
					url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/shipment/measure-weights/list`,
					entity: 'measureWeights',
					jsonData: {}
				}))
			}).then(() => {
				if (parmas?.id > 0) {
					fetchLeadById()
					setIsLoading(false)
				} else {
					setIsLoading(false)
				}
			})
		},
		[]
	)
	useEffect(
		() => {

			if (isQuery) {
				setLeadDetails(leadQuery?.result?.items?.Message)
			}
		},
		[isQuery]
	)
	const handleFormSubmit = async (event: any) => {
		event?.preventDefault()
		const fromAddressData = _.split(pickupLocations?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(leads.create({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leads', jsonData: {
				Records: [
					{
						Context: {},
						Message: {
							LeadInfo: {
								Name: selectedLead?.Name,
								Email: selectedLead?.Email,
								PhoneNumber: selectedLead?.PhoneNumber,
								date: selectedLead?.date,
								Description: selectedLead?.Description,
								IsExistingUser: false,
								LeadPayload: {
									weight: {
										unit: selectedLead?.weightUnit,
										value: selectedLead?.weightValue
									},
									dimensions: {
										length: {
											unit: selectedLead?.lengthUnit,
											value: selectedLead?.lengthValue
										},
										breadth: {
											unit: selectedLead?.breadthUnit,
											value: selectedLead?.breadthValue
										},
										height: {
											unit: selectedLead?.heightUnit,
											value: selectedLead?.heightValue
										}
									},
									category: '',
									value: {
										currency: 'INR',
										value: selectedLead?.value
									},
									dangerous_goods: selectedLead?.dangerous_goodsfalse
								},
								start: {
									location: {
										gps: `${pickupLocations?.lat},${pickupLocations?.long}`,
										address: {
											name: pickupLocations?.name,
											building: pickupLocations?.description,
											locality: `${fromAddressData[0]},${fromAddressData[1]}`,
											city: pickupLocations?.name,
											state: fromAddressData[3],
											country: 'India',
											area_code: pickupLocations?.pincode,
										},
									},
								},

								end: {
									location: {
										gps: `${dropLocations?.lat},${dropLocations?.long}`,
										address: {
											name: dropLocations?.name,
											building: dropLocations?.description,
											locality: `${toAddressData[0]},${toAddressData[1]}`,
											city: dropLocations?.name,
											state: toAddressData[3],
											country: 'India',
											area_code: dropLocations?.pincode,
										},
									},
								},
							}
						}

					}
				]
			}
		}))

			.then(() => {
				setPickupLocation({
					name: '',
					lat: '',
					long: '',
					pincode: '',
					description: ''
				})
				setDropLocation({
					name: '',
					lat: '',
					long: '',
					pincode: '',
					description: ''
				})
				back()
			})
	}

	const back = () => {
		navigate('/management/logistics/transport/leads')
	}

	return (
		<>
			{isLoading ? <PageLoader /> :
				<LeadComponent
					leadDetails={leadDetails}
					getCategoryName={getCategoryName}
					back={back}
					id={parmas?.id}
					distances={measureDimensionsLists?.result?.items}
					weights={measureWeightLists?.result?.items}
					handleFormSubmit={handleFormSubmit}
					dropLocations={dropLocations}
					setDropLocation={setDropLocation}
					pickupLocations={pickupLocations}
					setPickupLocation={setPickupLocation}
					selectedLead={selectedLead}
					handleInnerFormChange={handleInnerFormChange}
				/>}
		</>
	)

}

export default ManagementTransportLead;